export default __webpack_public_path__ + "static/real-world-cta-3e43db2a1588d117030d0005bfbaa864.webp";